import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { ReportService } from 'src/app/_service/report.service';
import { SharedService } from '../../_service/shared.service';
declare var $: any;

@Component({
  selector: 'app-feedback-tapping-report',
  templateUrl: './feedback-tapping-report.component.html',
  styleUrls: ['./feedback-tapping-report.component.css']
})
export class FeedbackTappingReportComponent implements OnInit {

  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  todayDate: Date = new Date();
  myrole: string; loaded: boolean = false; start_date: string = ''; end_date: string = '';
  opd_start_date: string = ''; opd_end_date: string = ''; opd_report_loading: boolean = false; opdReportList = [];
  ipd_start_date: string = ''; ipd_end_date: string = ''; ipd_report_loading: boolean = false; ipdReportList = [];
  bds = []; bds_copy = []; bd: string; userId: string;
  constructor(public reportpi: ReportService, private sharedapi: SharedService, private leadapi: LeadsService) {
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
  }

  ngOnInit(): void {
    if (this.myrole == '1' || this.userId == '268' || this.userId == '313') {
      this.getbds();
      this.getOpdTappingReportList();
      this.getIpdTappingReportList();
    }
  }

  async getOpdTappingReportList() {
    let qString = 'bd=' + this.bd;
    this.loaded = false;
    this.opd_report_loading = true;
    this.opd_start_date = '';
    this.opd_end_date = '';
    await this.reportpi.getOpdfeedbackReportData(qString).subscribe((data: any) => {
      this.opd_report_loading = false;
      this.loaded = true;
      this.opd_start_date = this.start_date;
      this.opd_end_date = this.end_date;
      if (data.status) {
        this.opdReportList = data.data;
      } else {
        this.opdReportList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
      this.loaded = true;
    });
  }

  async getIpdTappingReportList() {
    let qString = 'bd=' + this.bd;
    this.loaded = false;
    this.ipd_report_loading = true;
    this.ipd_start_date = '';
    this.ipd_end_date = '';
    await this.reportpi.getIpdfeedbackReportData(qString).subscribe((data: any) => {
      this.ipd_report_loading = false;
      this.loaded = true;
      this.ipd_start_date = this.start_date;
      this.ipd_end_date = this.end_date;
      if (data.status) {
        this.ipdReportList = data.data;
      } else {
        this.ipdReportList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
      this.loaded = true;
    });
  }

  async getbds(status = 1) {
    this.leadapi.getFeedbackUsers(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type) {
    if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  OpdresetFilters() {
    this.bd = '';
    this.getOpdTappingReportList();
  }
  IpdresetFilters() {
    this.bd = '';
    this.getIpdTappingReportList();
  }

}
